export const getTrending = (state) => state.trending.trending
export const getLoadingTrending = (state) => state.trending.isLoading
export const getLoadedTrending = (state) => state.content.isLoaded



// WEBPACK FOOTER //
// ./src/selectors/trending.js